// extracted by mini-css-extract-plugin
module.exports = {"content":"product-module__content___4aJ3U"};